import React, { useEffect, useState } from "react";
import { formatterCurrency, isValidUrl } from "../../Utils/Utils";
import { pdf } from "../../Images";

const ProductDetailInformationView = ({ productDetail, productColors, productTags }) => {
  const [productColor, setProductColor] = useState("");
  const [productTag, setProductTag] = useState("");

  useEffect(() => {
    if (productDetail?.id_color) {
      const selectedColor = productColors.find((color) => color?.id_color == productDetail?.id_color);
      setProductColor(selectedColor ? selectedColor.color : "");
    }

    if (productDetail?.id_tag) {
      const selectedTag = productTags.find((tag) => tag?.id_tag == productDetail?.id_tag);
      setProductTag(selectedTag ? selectedTag.title : "");
    }
  }, [productDetail?.id_color, productDetail?.id_tag, productColors, productTags]);

  return (
    <>
      <div style={{ padding: "0 0.5rem" }}>
        <h5
          style={{
            marginTop: "1rem",
            marginBottom: "1.1rem",
            fontWeight: "200",
            borderBottom: "1px solid black",
            paddingBottom: "0.3rem",
          }}
        >
          Product Profile
        </h5>
        <div className="row pt-2">
          <div className="col-md-4">
            <div className="text-secondary">Title</div>
            <p>{(productDetail && productDetail.title) || "-"}</p>
          </div>
          <div className="col-md-4">
            <div className="text-secondary">Tagline</div>
            <p>{(productDetail && productDetail.tagline) || "-"}</p>
          </div>
          <div className="col-md-4">
            <div className="text-secondary">Price</div>
            <p>{(productDetail && formatterCurrency(productDetail.price)) || "-"}</p>
          </div>
        </div>

        <div className="row pt-2">
          <div className="col-md-4">
            <div className="text-secondary">Header Description</div>
            <p className="text-break" style={{ whiteSpace: "pre-wrap" }}>
              {(productDetail && productDetail.header_description) || "-"}
            </p>
          </div>
          <div className="col-md-4">
            <div className="text-secondary">Description</div>
            <p className="text-break" style={{ whiteSpace: "pre-wrap" }}>
              {(productDetail && productDetail.description) || "-"}
            </p>
          </div>
          <div className="col-md-4">
            <div className="text-secondary">Manual Book</div>
            {!productDetail.manual_book || productDetail.manual_book == "null" ? (
              <p>-</p>
            ) : (
              <div className="d-flex align-items-center pt-2">
                <div style={{ position: "relative" }}>
                  <img
                    src={pdf}
                    style={{
                      objectFit: "contain",
                      width: "60px",
                      height: "60px",
                      cursor: "pointer",
                    }}
                  />
                </div>
                <div className="px-2">
                  <p>{productDetail.manual_book}</p>
                  {isValidUrl(productDetail.manual_book) && (
                    <a href={productDetail.manual_book} target="_blank" download className="btn btn-warning btn-md ml-3" style={{ width: "30%" }}>
                      Download
                    </a>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="row pt-2">
          <div className="col-md-4">
            <div className="text-secondary">Feature</div>
            <p className="text-break" style={{ whiteSpace: "pre-wrap" }}>
              {(productDetail && productDetail.feature) || "-"}
            </p>
          </div>
          <div className="col-md-4">
            <div className="text-secondary">Including</div>
            <p className="text-break" style={{ whiteSpace: "pre-wrap" }}>
              {(productDetail && productDetail.including) || "-"}
            </p>
          </div>
        </div>
        <div className="row pt-2">
          <div className="col-md-4">
            <div className="text-secondary">Product Color</div>
            <p>{(productColor && productColor) || "-"}</p>
          </div>
          <div className="col-md-4">
            <div className="text-secondary">Product Tag</div>
            <p className="text-break" style={{ whiteSpace: "pre-wrap" }}>
              {(productTag && productTag) || "-"}
            </p>
          </div>
        </div>
      </div>

      <div style={{ padding: "0 0.5rem" }}>
        <h5
          style={{
            marginTop: "1rem",
            marginBottom: "1.1rem",
            fontWeight: "200",
            borderBottom: "1px solid black",
            paddingBottom: "0.3rem",
          }}
        >
          Website & SEO Details
        </h5>
        <div className="row pt-2">
          <div className="col-md-6">
            <div className="text-secondary">SEO Title</div>
            <p>{(productDetail && productDetail.seo_title) || "-"}</p>
          </div>
          <div className="col-md-6">
            <div className="text-secondary">Product Display Name</div>
            <p>{(productDetail && productDetail.product_display_name) || "-"}</p>
          </div>
        </div>

        <div className="row pt-2">
          <div className="col-md-6">
            <div className="text-secondary">SEO Description</div>
            <p className="text-break" style={{ whiteSpace: "pre-wrap" }}>
              {(productDetail && productDetail.seo_description) || "-"}
            </p>
          </div>
          <div className="col-md-6">
            <div className="text-secondary">URL AR</div>
            <p>{(productDetail && productDetail.url_ar) || "-"}</p>
          </div>
        </div>
      </div>

      <div style={{ padding: "0 0.5rem" }}>
        <h5
          style={{
            marginTop: "1rem",
            marginBottom: "1.1rem",
            fontWeight: "200",
            borderBottom: "1px solid black",
            paddingBottom: "0.3rem",
          }}
        >
          Product Status
        </h5>

        <div className="row pt-2">
          <div className="col-md-4">
            <div className="text-secondary">Preorder</div>
            <p className={productDetail.is_preorder ? "text-success" : "text-danger"}>{productDetail.is_preorder ? "Yes" : "No"}</p>
          </div>
          <div className="col-md-4">
            <div className="text-secondary">Rental</div>
            <p className={productDetail.is_rental ? "text-success" : "text-danger"}>{productDetail.is_rental ? "Yes" : "No"}</p>
          </div>
          <div className="col-md-4">
            <div className="text-secondary">Active</div>
            <p className={productDetail.is_active ? "text-success" : "text-danger"}>{productDetail.is_active ? "Yes" : "No"}</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductDetailInformationView;
